// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from 'material-ui/Chip';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

// Internal Dependencies
import connectComponent from '../connect-component';
import styles from '../styles/Styles';
import { fetchBadges } from '../state/actions/badge-actions';

// Local variables
const propTypes = {
  badges: PropTypes.arrayOf(PropTypes.object),
  fetchBadges: PropTypes.func,
};

const thisStyle = styles.badgeList;

// Component definition
class BadgeList extends Component {
  componentWillMount() {
    this.props.fetchBadges();
  }

  render() {
    const { badges } = this.props;

    if (this.props.badges !== null) {
      return (
        <div style={thisStyle.mainSection}>
          {
            Object.keys(badges).map((key, index) => {
              const image = `${window.location.pathname}images/badges/${badges[key].image}`;
              const str = badges[key].category;
              const categoryList = str.split(',');

              return (
                <Paper
                  key={key}
                  rounded={false}
                  style={thisStyle.container}
                  zDepth={5}
                >
                  <div>
                    <img alt={image} src={image} style={thisStyle.badgeImage} />
                    <div key={index} style={thisStyle.badgeInfoSection}>
                      <div style={thisStyle.badgeTitleText}>{badges[key].name}</div>
                      <Divider />
                      <div style={thisStyle.infoDiv}>
                        <div style={thisStyle.infoInnerDiv}>
                          {categoryList.map((item, i) =>
                            (
                              <Chip
                                key={i}
                                labelColor={thisStyle.labelColor}
                                style={thisStyle.categoryChip}
                              >
                                {item}
                              </Chip>
                            ))
                          }
                        </div>
                        <div style={thisStyle.badgeCardText}>
                          <div style={thisStyle.badgeSubtitleText}>Description :</div>
                          {badges[key].description}
                        </div>
                      </div>
                    </div>
                  </div>
                </Paper>
              );
            })
          }
        </div>
      );
    }
    return null;
  }
}

BadgeList.propTypes = propTypes;
export default connectComponent(state => ({
  badges: state.badges,
}), {
  fetchBadges,
},
BadgeList,
);



/** WEBPACK FOOTER **
 ** ./src/badges/BadgeList.js
 **/